module.exports = __webpack_public_path__ + "img/p2.370261bf.png";